import React from "react";
import img1 from "./images/illustration/services-img-4.jpg";
import img2 from "./images/illustration/services-img-1.jpg";
import img3 from "./images/illustration/services-img-6.jpg";
import img4 from "./images/illustration/services-img-7.jpg";
import img5 from "./images/illustration/fitness-img-1.jpg";
import img6 from "./images/illustration/services-img-1.jpg";
import img7 from "./images/illustration/services-img-2.jpg";
import img8 from "./images/illustration/services-img-3.jpg";
import img9 from "./images/illustration/services-img-4.jpg";
import img10 from "./images/illustration/video-img-1-1024x512.jpg";
import img11 from "./images/illustration/personal-trainer-img-4.jpg";

const Services = () => {
  return (
    <>
      <div className="container-fluid g-0" id="image2">
        <div className="row">
          <div className="col-12">
            <h2 className="text-white fw-bold heading">
              <span className="text-warning"> OUR SERVICES</span>
            </h2>
            <p className="fw-bold text-white fs-5">BACK HOME</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="row">
            <div className="col-12 col-md-8 text-center">
              <h2 className="heading fw-bold mb-4">My Services</h2>
              <p>BY KRIS ROHER</p>
              <p>
                Tristique diam dictumst diam orci dolor congue.
                <br /> Pretium morbi tincidunt sed semper turpis a at nisi. Erat
                lect.
              </p>
              <p>ALL SERVICES</p>
            </div>
            <div className="col-12 col-md-4">
              <img src={img2} alt="image not found" className="img-fluid" />
            </div>

            <div className="col-12 col-md-4">
              <img src={img3} alt="image not found" className="img-fluid" />
            </div>
            <div className="col-12 col-md-8" id="set2">
              <img src={img4} alt="image not found" className="img-fluid " />
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 " id="set">
          <img src={img1} alt="image not found" className="img-fluid" />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 mt-5">
          <img
            src={img5}
            alt="image not found"
            className="img-fluid w-75 align-items-center ms-5"
          />
        </div>
        <div className="col-12 col-md-6 mt-5">
          <h2 className="heading fw-bold mb-4">REACH YOUR BODY GOALS</h2>
          <p className="fw-bold">
            Convallis ullamcorper velit, varius maecenas viverra purus nunc. In
            suscipit aliquet sociis nibh quis. Neque pellentesque habitant
            aliquet venenatis at est.
          </p>
          <p>Cardio Training</p>
          <p>Basic Yoga</p>
          <p>Muscle Training</p>
          <p>Stretching</p>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12">
          <h2 className="heading fw-bold mb-4">OUR BEST CLASSES</h2>
          <p className="fw-bold ms-2">
            Quisque velit sit viverra fermentum risus sed ac nisl <br /> Eu
            risus tempus ultrices aliquam ornare eget tristique quisque. Aenean
            pla.
          </p>
        </div>
        <div className="col-12 col-md-3">
          <img src={img6} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-12 col-md-3">
          <img src={img7} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-12 col-md-3">
          <img src={img8} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-12 col-md-3">
          <img src={img9} alt="image not found" className="img-fluid" />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <h2 className="heading fw-bold mb-4 text-center mt-5">
            WATCH HOW WE WORK
          </h2>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <img src={img10} alt="image not found" className="img-fluid w-100" />
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12">
          <h2 className="heading fw-bold mb-4 text-center">
            OUR PRICING PLANS
          </h2>
          <p className="text-center fw-bold ms-2">
            Lacinia bibendum sed dictumst consectetur. Non adipiscing arcu vitae
            neque <br /> Felis enim sit gravida sem. Egestas quis pretium
            aliquet.
          </p>
        </div>
      </div>

      <div class="card-group">
        <div class="card">
          <div class="card-body" id="menu1">
            <h2 class="card-title">ONE-DAY VISIT $20/DAY</h2>
            <p className="fw-bold ms-2">urna neque mi dignissim</p>
            <p className="fw-bold ms-2">Neque,urna nibh proin leo integ</p>
            <p className="fw-bold ms-2">Vitae rhoncus eu vitae quam</p>
            <p className="fw-bold ms-2">Tortor praesent nisl orci</p>
            <button className="btn btn-outline-success" type="submit">
              PURCHASE NOW
            </button>
          </div>
        </div>
        <div class="card">
          <div class="card-body" id="menu2">
            <h2 class="card-title">MONTHLY PASS $49/MO</h2>
            <p className="fw-bold ms-2">Neque,urna nibh proin leo integ</p>
            <p className="fw-bold ms-2">urna neque mi dignissim</p>
            <p className="fw-bold ms-2">Vitae rhoncus eu vitae quam</p>
            <p className="fw-bold ms-2">Tortor praesent nisl orci</p>
            <button className="btn btn-outline-success" type="submit">
              PURCHASE NOW
            </button>
          </div>
        </div>
        <div class="card">
          <div class="card-body" id="menu3">
            <h2 class="card-title">YEARLY PASS $89/YR</h2>
            <p className="fw-bold ms-2">Neque,urna nibh proin leo integ</p>
            <p className="fw-bold ms-2">urna neque mi dignissim</p>
            <p className="fw-bold ms-2">Vitae rhoncus eu vitae quam</p>
            <p className="fw-bold ms-2">Tortor praesent nisl orci</p>
            <button className="btn btn-outline-success" type="submit">
              PURCHASE NOW
            </button>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12 col-md-6">
          <img src={img11} alt="iamge not found" className="img-fluid" />
        </div>
        <div className="col-12 col-md-6 mt-5">
          <h2 className="heading fw-bold mb-4">HAVE ANY QUESTIONS?</h2>
          <form>
            <div class="mb-3 mt-5">
              <label for="exampleInputEmail1" class="form-label">
                NAME
              </label>
              <input></input>
              <div id="emailHelp" class="form-text"></div>
            </div>
            <div class="mb-3 mt-5">
              <label for="exampleInputPassword1" class="form-label">
                E-MAIL
              </label>
              <input></input>
            </div>
            <div class="mb-3 form-check mt-5">
              <input></input>
              <label class="form-check-label">YOUR QUESTION</label>
            </div>
            <button type="submit" class="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
      </div>
      <div className="row bg-dark text-white">
      <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>WoxFit</h1>
              <p className="set2">
                Parturient porttitor quam mattis ipsum imperdiet habitasse orci.
                Risus integer.
              </p>
              <div className="icons">
              <i class="fab fs-3 me-4 fa-instagram"></i>
              <i class="fab fs-3 me-4 fa-twitter"></i>
              <i class="fab fs-3 me-4 fa-facebook"></i>

              </div>
            </div>
            <div className=" col-12 col-md-6 col-xl-3 mt-5 ">
              <h1>About</h1>
              <p className="set5">About us</p>
              <p className="set5">Blog</p>
              <p className="set5">Careers</p>
              <p className="set5">Jobs</p>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>Services</h1>
              <p className="box10">How we work</p>
              <p className="box10">Portfolio</p>
              <p className="box10">Pricing</p>
              <p className="box10">More</p>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>Support</h1>
              <p>Contact us</p>
              <p>online chat</p>
              <p>Whatsapp</p>
              <p>Telegram</p>
              
            </div>
       
      </div>
    </>
  );
};
export default Services;
